import { DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuTrigger } from 'components/ui/dropdown-menu'
import { CirclePlus, EllipsisVertical, FolderPlus, SquarePen, Trash } from 'lucide-react'
import { CustomDialog } from "components/blocks/custom-dialog";
import { DebouncedInput } from "components/blocks/debounced-input/debounced-input";
import { useProjectActions } from '../hooks/use-project-actions';
import { useTranslation } from "react-i18next";
import { useEffect, useState } from 'react';
interface ProjectActionsDropdownProps {
    fetchedProject: any;
    refetchProject: () => void;
    setIsAddInstructionModalOpen: (isOpen: boolean) => void;
    setOpenFilesModal: (isOpen: boolean) => void;
    totalFiles: number;
}

function ProjectActionsDropdown({ fetchedProject, refetchProject, setIsAddInstructionModalOpen, setOpenFilesModal, totalFiles }: ProjectActionsDropdownProps) {
    const { remove, rename, isDeleteLoading, isRenameLoading } = useProjectActions(fetchedProject?.id);
    const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
    const [isRenameDialogOpen, setIsRenameDialogOpen] = useState(false);
    const [newTitle, setNewTitle] = useState("");
    const [actionType, setActionType] = useState<"delete" | "rename" | null>(null);
    const { t } = useTranslation();

    const handleRename = async () => {
        if (newTitle.trim() === "") return;
        await rename(newTitle);
        setIsRenameDialogOpen(false);
    };

    const handleRemove = async () => {
        await remove();
        setIsConfirmDialogOpen(false);
    };

    const handleConfirmAction = () => {
        if (actionType === "rename") handleRename();
        if (actionType === "delete") handleRemove();
    };

    useEffect(() => {
        if (fetchedProject?.name) {
            setNewTitle(fetchedProject.name);
        }
    }, [fetchedProject?.name]);

    if (!fetchedProject) return null;

    console.log('fetchedProject', fetchedProject,)

    return (
        <>
            <DropdownMenu modal={false}>
                <DropdownMenuTrigger asChild>
                    <button className="p-1.5 rounded-md hover:bg-muted-foreground/10">
                        <EllipsisVertical size={16} className="cursor-pointer text-primary" />
                    </button>
                </DropdownMenuTrigger>
                <DropdownMenuContent
                    className="w-56  border  shadow-lg rounded-2xl p-1"
                    align="end"
                    sideOffset={8}
                >
                    <DropdownMenuGroup>
                        <DropdownMenuItem onClick={() => {
                            setActionType("rename");
                            setIsRenameDialogOpen(true);
                        }} className="flex items-center gap-3 px-3 py-2.5 text-sm rounded-md cursor-pointer transition-colors hover:bg-muted-foreground/10">
                            <SquarePen size={16} className="text-primary" />
                            <span className="text-sm font-normal">{t("EDIT_PROJECT")}</span>
                        </DropdownMenuItem>

                        <DropdownMenuItem onClick={() => setOpenFilesModal(true)} className="flex items-center gap-3 px-3 py-2.5 text-sm rounded-md cursor-pointer transition-colors hover:bg-muted-foreground/10">
                            <CirclePlus size={16} className="text-primary" />
                            <span className="text-sm font-normal">{t("FILES")}({totalFiles})</span>
                        </DropdownMenuItem>


                        <DropdownMenuItem onClick={
                            async () => {
                                if (fetchedProject) {
                                    setIsAddInstructionModalOpen(true);
                                } else {
                                    refetchProject();
                                    setIsAddInstructionModalOpen(true);
                                }
                            }
                        } className="flex items-center gap-3 px-3 py-2.5 text-sm rounded-md cursor-pointer transition-colors hover:bg-muted-foreground/10">
                            <FolderPlus size={16} className="text-primary" />
                            <span className="text-sm font-normal">{t("ADD_INSTRUCTION")}</span>
                        </DropdownMenuItem>
                        <div className="border-t border-muted-foreground/25 my-1"></div>
                        <DropdownMenuItem onClick={() => {
                            setActionType("delete");
                            setIsConfirmDialogOpen(true);
                        }} className="flex items-center gap-3 px-3 py-2.5 text-sm rounded-md cursor-pointer transition-colors hover:bg-muted-foreground/10">
                            <Trash size={16} className="text-destructive" />
                            <span className="text-sm font-normal">{t("DELETE_PROJECT")}</span>
                        </DropdownMenuItem>
                    </DropdownMenuGroup>
                </DropdownMenuContent>
            </DropdownMenu>

            <CustomDialog
                isOpen={isConfirmDialogOpen}
                isLoading={isDeleteLoading}
                setIsOpen={setIsConfirmDialogOpen}
                title={t("CONFIRM_ACTION")}
                onConfirm={handleConfirmAction}
                confirmText={t("YES")}
                cancelText={t("CANCEL")}
                description={""}
            >
                <p>{t("CONFIRM_ACTION_DESCRIPTION")}</p>
            </CustomDialog>

            <CustomDialog
                isOpen={isRenameDialogOpen}
                isLoading={isRenameLoading}
                setIsOpen={setIsRenameDialogOpen}
                title={t("RENAME")}
                onConfirm={handleConfirmAction}
                confirmText={t("SAVE")}
                cancelText={t("CANCEL")}
                isConfirmDisabled={newTitle.trim() === ""}
                description={""}
            >
                <DebouncedInput
                    placeholder={t("ENTER_NEW_TITLE")}
                    initialValue={newTitle}
                    onDebouncedChange={setNewTitle}
                    className="
                                        h-10 w-full rounded-3xl
                                        border border-primary
                                        bg-background pr-8
                                        focus:outline-none
                                        focus:border-primary
                                        focus:ring-1 focus:ring-primary
                                    "
                />
            </CustomDialog>
        </>
    )
}

export default ProjectActionsDropdown